import React, { useEffect, useRef, useState, useMemo } from "react";
import {
  Row,
  Col,
  Card,
  CardBody,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  Container,
} from "reactstrap";
import { useDispatch, useSelector } from "react-redux";
import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";
import interactionPlugin, { Draggable } from "@fullcalendar/interaction";
import BootstrapTheme from "@fullcalendar/bootstrap";
import { isEmpty } from "lodash";

import Breadcrumbs from "../../components/Common/Breadcrumb";
import DeleteModal from "./DeleteModal";

import {
//  getEvents,
  addNewEvent,
  updateEvent,
  deleteEvent,
  getCategories,
} from "../../store/actions";

const Calendar = () => {
  const dispatch = useDispatch();
  const calendarRef = useRef(null);

  //const events = useSelector((state) => state.Calendar.events);
 // const categories = useSelector((state) => state.Calendar.categories);
  const categories = [
    { title: "Meeting", type: "bg-success" },
    { title: "Workshop", type: "bg-warning" },
    { title: "Birthday", type: "bg-danger" },
    { title: "Custom", type: "bg-info" },
    { title: "Create New theme", type: "bg-info" },
  ];

  const [modal, setModal] = useState(false);
  const [modalCategory, setModalCategory] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const [selectedDay, setSelectedDay] = useState(null);
  const [event, setEvent] = useState({});
  const [isEdit, setIsEdit] = useState(false);
  const [showHolidayDebug, setShowHolidayDebug] = useState(false); // 👈 debug toggle

  const breadcrumbItems = [
    { title: "valfuel", link: "/" },
    { title: "Calendar", link: "#" },
  ];
  const events = [
    {
      id: 1,
      title: "Parent-Teacher Meeting",
      start: "2025-04-10T10:00:00",
      className: "bg-info text-white",
    },
    {
      id: 2,
      title: "Math Midterm Exam - Grade 10",
      start: "2025-04-15T09:00:00",
      className: "bg-danger text-white",
    },
    {
      id: 3,
      title: "Annual Sports Day",
      start: "2025-04-20T08:00:00",
      className: "bg-success text-white",
      allDay: true,
    },
    {
      id: 4,
      title: "Science Project Submission",
      start: "2025-04-25T11:30:00",
      className: "bg-warning text-white",
    },
    {
      id: 5,
      title: "School Council Elections",
      start: "2025-04-30T13:00:00",
      className: "bg-primary text-white",
    },
    {
      id: 6,
      title: "May Day Holiday",
      start: "2025-05-01",
      className: "bg-dark text-white",
      allDay: true,
    },
    {
      id: 7,
      title: "Art & Craft Exhibition",
      start: "2025-05-05T10:00:00",
      className: "bg-info text-white",
    },
    {
      id: 8,
      title: "English Literature Test - Grade 9",
      start: "2025-05-10T09:00:00",
      className: "bg-danger text-white",
    },
    {
      id: 9,
      title: "Field Trip to Science Museum",
      start: "2025-05-15T07:30:00",
      className: "bg-success text-white",
    },
    {
      id: 10,
      title: "PTA Committee Review Meeting",
      start: "2025-05-20T14:00:00",
      className: "bg-warning text-white",
    },
  ];
    
  useEffect(() => {
   // dispatch(getEvents());
    dispatch(getCategories());

    new Draggable(document.getElementById("external-events"), {
      itemSelector: ".external-event",
    });
  }, [dispatch]);

  useEffect(() => {
    if (!modal && !isEmpty(event)) {
      setTimeout(() => {
        setEvent({});
        setIsEdit(false);
      }, 500);
    }
  }, [modal, event]);

  const toggle = () => setModal(!modal);
  const toggleCategory = () => setModalCategory(!modalCategory);

  const handleDateClick = (arg) => {
    const date = new Date(arg.date);
    const currectDate = new Date();
    date.setHours(currectDate.getHours(), currectDate.getMinutes(), currectDate.getSeconds());

    setSelectedDay({ ...arg, date });
    toggle();
  };

  const handleEventClick = (arg) => {
    const evt = arg.event;
    setEvent({
      id: evt.id,
      title: evt.title,
      title_category: evt.title_category,
      start: evt.start,
      className: evt.classNames,
      category: evt.classNames[0],
      event_category: evt.classNames[0],
    });
    setIsEdit(true);
    toggle();
  };

  const handleValidEventSubmit = (e) => {
    e.preventDefault();
    const formData = new FormData(e.target);
    const title = formData.get("title");
    const category = formData.get("category");

    if (isEdit) {
      dispatch(updateEvent({
        id: event.id,
        title,
        classNames: category + " text-white",
        start: event.start,
      }));
    } else {
      dispatch(addNewEvent({
        id: Math.floor(Math.random() * 100),
        title,
        start: selectedDay ? selectedDay.date : new Date(),
        className: category + " text-white",
      }));
    }

    setSelectedDay(null);
    toggle();
  };

  // Holidays
  const holidayEvents = [
    {
      id: "h1",
      title: "Independence Day",
      start: "2025-07-04",
      className: "bg-danger text-white",
      allDay: true
    },
    {
      id: "h2",
      title: "New Year's Day",
      start: "2025-01-01",
      className: "bg-warning text-white",
      allDay: true
    }
  ];

 
  const allEvents = useMemo(() => {
    return [...(events || []), ...holidayEvents];
  }, [events]);

  const handleValidEventSubmitCategory = (e) => {
    e.preventDefault();
    const formData = new FormData(e.target);
    const title_category = formData.get("title_category");
    const event_category = formData.get("event_category");

    dispatch(addNewEvent({
      id: Math.floor(Math.random() * 100),
      title: title_category,
      start: new Date(),
      className: (event_category || "bg-danger") + " text-white",
    }));
    toggleCategory();
  };

  const handleDeleteEvent = () => {
    dispatch(deleteEvent(event));
    setDeleteModal(false);
    toggle();
  };

  const onDrag = (event) => event.preventDefault();

  const onDrop = (info) => {
    const date = new Date(info.date);
    const currectDate = new Date();
    date.setHours(currectDate.getHours(), currectDate.getMinutes(), currectDate.getSeconds());

    const newEvent = {
      id: Math.floor(Math.random() * 100),
      title: info.draggedEl.innerText,
      start: date,
      className: info.draggedEl.className,
    };

    dispatch(addNewEvent(newEvent));
  };

  return (
    <>
      <DeleteModal
        show={deleteModal}
        onDeleteClick={handleDeleteEvent}
        onCloseClick={() => setDeleteModal(false)}
      />

      <div className="page-content">
        <Container fluid>
          <Breadcrumbs title="Calendar" breadcrumbItems={breadcrumbItems} />
          <Row className="mb-4">
            <Col xl={3}>
              <Card className="h-100">
                <CardBody>
                  <Button
                    color="primary"
                    className="w-100"
                    onClick={toggleCategory}
                  >
                    Create New Event
                  </Button>
                  <div id="external-events" className="mt-4">
                    <p className="text-muted">
                      Drag and drop your event or click in the calendar
                    </p>
                    {categories?.map((cat, i) => (
                      <div
                        key={i}
                        className={`${cat.type} external-event fc-event text-white`}
                        draggable
                        onDrag={onDrag}
                      >
                        <i className="mdi mdi-checkbox-blank-circle font-size-11 me-2" />
                        {cat.title}
                      </div>
                    ))}
                  </div>
                </CardBody>
              </Card>
            </Col>

            <Col xl={9}>
              <Card className="mb-0">
                <CardBody>
                  <FullCalendar
                    ref={calendarRef}
                    plugins={[BootstrapTheme, dayGridPlugin, interactionPlugin]}
                    headerToolbar={{
                      left: "prev,next today",
                      center: "title",
                      right: "dayGridMonth,dayGridWeek,dayGridDay",
                    }}
                    slotDuration={"00:15:00"}
                    themeSystem="bootstrap"
                    events={allEvents}
                    editable
                    droppable
                    selectable
                    dateClick={handleDateClick}
                    eventClick={handleEventClick}
                    drop={onDrop}
                  />

                  {/* Event Modal */}
                  <Modal isOpen={modal} toggle={toggle} id="event-modal">
                    <ModalHeader toggle={toggle}>
                      {isEdit ? "Edit Event" : "Add Event"}
                    </ModalHeader>
                    <ModalBody>
                      <form onSubmit={handleValidEventSubmit}>
                        <Row>
                          <Col className="mb-3">
                            <label>Event Name</label>
                            <input
                              name="title"
                              type="text"
                              className="form-control"
                              defaultValue={event.title || ""}
                              required
                            />
                          </Col>
                          <Col className="mb-3">
                            <label>Select Category</label>
                            <select
                              name="category"
                              className="form-control"
                              defaultValue={event.category || "bg-primary"}
                              required
                            >
                              <option value="bg-danger">Danger</option>
                              <option value="bg-success">Success</option>
                              <option value="bg-primary">Primary</option>
                              <option value="bg-info">Info</option>
                              <option value="bg-dark">Dark</option>
                              <option value="bg-warning">Warning</option>
                            </select>
                          </Col>
                        </Row>
                        <div className="text-end">
                          <button type="button" className="btn btn-light me-2" onClick={toggle}>
                            Close
                          </button>
                          {isEdit && (
                            <button
                              type="button"
                              className="btn btn-danger me-2"
                              onClick={() => setDeleteModal(true)}
                            >
                              Delete
                            </button>
                          )}
                          <button type="submit" className="btn btn-success">
                            Save
                          </button>
                        </div>
                      </form>
                    </ModalBody>
                  </Modal>

                  {/* Category Modal */}
                  <Modal isOpen={modalCategory} toggle={toggleCategory}>
                    <ModalHeader toggle={toggleCategory}>Add a category</ModalHeader>
                    <ModalBody>
                      <form onSubmit={handleValidEventSubmitCategory}>
                        <div className="mb-3">
                          <label>Category Name</label>
                          <input
                            name="title_category"
                            type="text"
                            className="form-control"
                            required
                          />
                        </div>
                        <div className="mb-3">
                          <label>Choose Category Color</label>
                          <select
                            name="event_category"
                            className="form-control"
                            defaultValue="bg-danger"
                          >
                            <option value="bg-danger">Danger</option>
                            <option value="bg-success">Success</option>
                            <option value="bg-primary">Primary</option>
                            <option value="bg-info">Info</option>
                            <option value="bg-dark">Dark</option>
                            <option value="bg-warning">Warning</option>
                          </select>
                        </div>
                        <div className="text-end">
                          <button type="button" className="btn btn-light me-2" onClick={toggleCategory}>
                            Close
                          </button>
                          <button type="submit" className="btn btn-success">
                            Save
                          </button>
                        </div>
                      </form>
                    </ModalBody>
                  </Modal>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </>
  );
};

export default Calendar;
